import { GameId } from '@bg-shared/enums/GameId';
import gameNames from 'styles/base/gameNames.module.scss';

export const getStylingGameName = (gameId: GameId): string => gameNames[gameId];
